import { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import useMount from '../../hooks/useMount';
import processApi from "../../api/processApi";
import LoadingComponent from "../Commons/LoadingComponent";
import { setCurrentNavigation, removeFromHistory, getPreviousNavigation, getCurrentNavigation } from "../../slices/navigationSlice";
//import variableApi from "../../api/variableApi";
import productApi from "../../api/productApi";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ProcessPage from "../Process/ProcessPage";
import useAccess from "../../hooks/useAccess";


import { getLabel } from "../../tools/Dictionary";

const TroubleshootProcess = (props) =>
{

  //Navigation
  const Navigate = useNavigate();


  //Query
  let [searchParam] = useSearchParams();

  //Props
  const IsDesktop = props.IsDesktop;
  const Product = props.Product;
  const OnGoHome = props.OnGoHome;

  //Redux
  const Dispatch = useDispatch();
  const Access = useAccess(["Trouble"]);
  const PreviousNavigation = useSelector(getPreviousNavigation);
  const CurrentNavigation = useSelector(getCurrentNavigation);

  //State
  const [process, setProcess] = useState({});
  const [step, setStep] = useState([]);
  const [variable, setVariable] = useState([]);
  const [product, setProduct] = useState({});
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("TroubleProductProcess"));
    loadData();
  }, []);


  const loadData = async (_showLoading = true) =>
  {

    try
    {

      let currentProduct = Product;

      if (!currentProduct){

        currentProduct = {
          _id: searchParam.get('product'),
          process: searchParam.get('process')
        };

      }

      if (!currentProduct) throw new Error("");

      if (_showLoading)
      {
        setLoading(true);
      }

      let [processResponse, productResponse] = await Promise.all([
        processApi.getPublishProcessWithSteps({ _id: currentProduct.process }),
        //variableApi.getVariables({ filter: "process eq " + Product.process, select: `_id,name,description,process,variableType,variableTypeCode,variableTypeLabel,data,dataToDisplay`, translate: getLanguage().code, sort: "_id desc" }),
        productApi.getProduct(currentProduct._id)
      ]);

      //if (!variableResponse.Success) throw new Error(variableResponse.Error.label);

      if (!productResponse.Success) throw new Error(productResponse.Error.label);     

      if (processResponse.Success)
      {
        setProcess(processResponse.Data.Process);
        setStep(processResponse.Data.Step);

        processResponse.Data.Variable.forEach(v => {
          
          let foundParameter = productResponse.Data.processVariable.find(p => p.variable._id == v._id);

          if (foundParameter) {
            v.data = foundParameter.data;
            v.dataToDisplay = foundParameter.data;
          }

        });

        setVariable(processResponse.Data.Variable);

      } else
        throw new Error(processResponse.Error.label);


      // variableResponse.Data.forEach(v => {
        
      //   let foundParameter = productResponse.Data.processVariable.find(p => p.variable._id == v._id);

      //   if (foundParameter) {
      //     v.data = foundParameter.data;
      //     v.dataToDisplay = foundParameter.data;
      //   }

      // });

      // setVariable(variableResponse.Data);
      setProduct(productResponse.Data);



      setLoading(false);

    } catch (err)
    {

      Navigate("/troubleshoot");

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const onGoHome = () => {

    if (OnGoHome) {

      OnGoHome();
      return;

    }

    if (PreviousNavigation){


      Navigate(PreviousNavigation.url + (PreviousNavigation.urlParamsText || ""));
      Dispatch(removeFromHistory(CurrentNavigation));


    }


  };

  if (!Access.canRead)
    return (
      <div className="page_cont">
        <div className="page_message_text">
          {getLabel("App", "Access Denied: You don't have...")}
        </div>
      </div>
    );


  return (
    <div className="page_body_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <div className="page_cont">
        {!loading && process &&
          <ProcessPage
            IsDesktop={IsDesktop}
            Step={step}
            Process={process}
            Product={product}
            Variable={variable}
            OnGoHome={onGoHome}
          /> 
        }
      </div>
    </div>
  );

};

export default TroubleshootProcess